;(function () {
  angular.module('contrast.grid').directive('gridCount', function () {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        count: '=',
        message: '@',
        verticalCenter: '=?'
      },
      templateUrl: 'views/common/grid_count.html',
      link: function (scope) {
        scope.verticalCenter = angular.isDefined(scope.verticalCenter)
          ? scope.verticalCenter
          : true
      }
    }
  })
})()
